import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConsumoListarRoutingModule } from './consumo-listar-routing.module';
import { ConsumoListarComponent } from './consumo-listar.component';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from 'primeng/messages';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';


@NgModule({
  declarations: [
    ConsumoListarComponent
  ],
  imports: [
    CommonModule,
    ConsumoListarRoutingModule,
    FormsModule,
    TableModule,
    InputTextModule,
    DividerModule,
    ProgressSpinnerModule,
    MessagesModule,
    CalendarModule,
    ConfirmDialogModule
  ],
  providers: [ConfirmationService]
})
export class ConsumoListarModule { }
